import React from 'react';
import LoginBootstrap from 'src/components/pages/_loginBootstrap/loginBootstrap';

const ActivationLinkSent = React.lazy(() => import(/* webpackChunkName: "activationLinkSent" */ 'src/components/pages/login/activationLinkSent'));
const ChangePassword = React.lazy(() => import(/* webpackChunkName: "changePassword" */ 'src/components/pages/login/changePassword'));
const Login = React.lazy(() => import(/* webpackChunkName: "loginPage" */ 'src/components/pages/login/loginPage'));
const Register = React.lazy(() => import(/* webpackChunkName: "registerPage" */ 'src/components/pages/login/registerPage'));
const ResetPassword = React.lazy(() => import(/* webpackChunkName: "resetPassword" */ 'src/components/pages/login/resetPassword'));
const PermissionsLogin = React.lazy(() => import(/* webpackChunkName: "resetPassword" */ 'src/components/pages/permissions/permissionsLogin'));
const PermissionsSelection = React.lazy(
    () => import(/* webpackChunkName: "resetPassword" */ 'src/components/pages/permissions/permissionsLoginSellerSelection')
);
const PermissionsCompleted = React.lazy(
    () => import(/* webpackChunkName: "resetPassword" */ 'src/components/pages/permissions/permissionsLoginSellerSelectionCompleted')
);

const routesToLogin = [
    { url: '', component: LoginBootstrap },
    { url: '/', component: LoginBootstrap },
    { url: '/ActivationLinkSent', component: ActivationLinkSent },
    { url: '/ChangePassword', component: ChangePassword },
    { url: '/ResetPassword', component: ResetPassword },
    { url: '/Login', component: Login },
    { url: '/Register', component: Register },
    { url: '/user_login', component: PermissionsLogin },
    { url: '/user_login_selection', component: PermissionsSelection },
    { url: '/user_login_selection_completed', component: PermissionsCompleted }
];

export default routesToLogin;
